{
  "comment.section.title": "Comments",
  "comment.empty": "No comments yet.",
  "comment.placeholder": "Add a comment…",
  "comment.submit": "Comment",
  "comment.edited": "(edited)",
  "comment.author.unknown": "Unknown",
  "comment.action.edit": "Edit",
  "comment.action.delete": "Delete",
  "comment.action.deleting": "…",
  "comment.confirm.delete": "Delete this comment?",
  "comment.editor.placeholder": "Write a comment…",
  "comment.editor.submit": "Save",
  "comment.editor.submitting": "Saving…",
  "comment.editor.cancel": "Cancel",
  "comment.editor.update": "Update",
  "comment.editor.ariaLabel": "Comment text",
  "comment.editor.uploads.ariaLabel": "File uploads",
  "comment.editor.error.empty": "Comment cannot be empty",
  "comment.editor.error.saveFailed": "Failed to save comment",
  "comment.editor.error.uploadFailed": "Failed to upload attachment",
  "comment.deleted.ariaLabel": "Deleted comment",
  "comment.deleted.text": "[deleted]",
  "comment.relativeTime.justNow": "just now",
  "comment.relativeTime.minAgo": "min ago",
  "comment.relativeTime.hrAgo": "hr ago",
  "comment.draft.unsaved": "Unsaved comment draft restored",
  "comment.draft.unsavedOffline": "Unsaved comment (will post when back online)",
  "comment.draft.discard": "Discard",
  "comment.draft.discardFooter": "Discard draft",
  "comment.draft.saving": "Saving draft…",
  "comment.draft.savedLocal": "Draft saved locally",
  "comment.draft.syncing": "Syncing draft…",
  "comment.draft.synced": "Synced draft",
  "comment.draft.willSync": "Will post when back online",
  "comment.draft.syncFailed": "Sync failed",
  "comment.draft.postFailed": "Post failed",
  "comment.draft.retry": "Retry",
  "comment.draft.retryPost": "Retry Post",
  "comment.assetPicker.title": "Insert attachment",
  "comment.assetPicker.close": "Close picker",
  "comment.assetPicker.uploadNew": "Upload from computer",
  "comment.assetPicker.existingTitle": "Card attachments",
  "comment.assetPicker.empty": "No attachments yet",
  "comment.assetPicker.insert": "Insert",
  "comment.reactions.add": "Add reaction",
  "comment.reactions.aria.pill": "{{emoji}} {{count}} reaction, {{state}}",
  "comment.action.reply": "Reply",
  "comment.replies.viewOne": "View 1 reply",
  "comment.replies.viewMany": "View {{count}} replies",
  "comment.replies.hide": "Hide replies",
  "comment.reply.placeholder": "Write a reply…",
  "comment.reply.submit": "Reply",
  "comment.link.configureAria": "Configure link",
  "comment.link.configureTitle": "Configure link",
  "comment.link.displayFullUrlTitle": "Display full URL",
  "comment.link.displayFullUrlAria": "Display full URL",
  "comment.link.displayAsButtonTitle": "Display as button",
  "comment.link.displayAsButtonAria": "Display as button",
  "comment.link.displayAsCardTitle": "Display as card",
  "comment.link.displayAsCardAria": "Display as card",
  "comment.link.editTitle": "Edit link",
  "comment.link.editAria": "Edit link",
  "comment.link.openInNewTabTitle": "Open Link In New Tab",
  "comment.link.openInNewTabAria": "Open Link In New Tab",
  "comment.link.copyTitle": "Copy link",
  "comment.link.copyAria": "Copy link",
  "comment.link.deleteTitle": "Delete link",
  "comment.link.deleteAria": "Delete link",
  "comment.link.searchPlaceholder": "Paste or search for link",
  "comment.link.displayTextPlaceholder": "Display text (optional)",
  "comment.link.editUrlLabel": "Link",
  "comment.link.editTextLabel": "Display text",
  "comment.link.cancel": "Cancel",
  "comment.link.save": "Save"
}